import { IGetDisciplinasArquivosByIdUseCase } from "../../../presentation/useCases/read/get_disciplinas_arquivos_by_id_use_case";
import { GetDisciplinasArquivosByIdRequestModel, GetDisciplinasArquivosByIdResponseModel } from "../../models/disciplina_arquivo_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetDisciplinasArquivosByIdUseCase
 */

export class GetDisciplinasArquivosByIdUseCase implements IGetDisciplinasArquivosByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getDisciplinasArquivosById(model: GetDisciplinasArquivosByIdRequestModel): Promise<GetDisciplinasArquivosByIdResponseModel> {
    return await this.repository.getByIdDisciplinaArquivo(model);
  }
}
